import React from "react";
import FlightSearchWidget from "../helpers/FlightSearchWidget";
import RecommendedTrips from "./RecommendedTrips";
import TravelFeatures from "../helpers/TravelFeatures";
import FeaturedPartners from "../helpers/FeaturedPartners";
import UnderMaintenance from "../pages/UnderMaintenance";

const Home = () => {
  return (
    <div>
      {/* <FlightSearchWidget />
      <FeaturedPartners />
      <RecommendedTrips />
      <TravelFeatures /> */}
      <UnderMaintenance />
    </div>
  );
};

export default Home;
